/*
 * The tenant's logo (or name) for the top bar and the sign-in card; the sign-in card also shows
 * the DEMO tag on sales demos (in the app it sits next to the user button, see TopNav). Logo
 * height: the tenant's `logoHeight` setting, else 12 px (the Figma wordmark size).
 *
 * DemoTag (not in Figma, DESIGN-SPEC §6): the one small DEMO tag, the same in the top bar and on
 * the sign-in card: 11/14 semibold, tracking 0.5px, --text-warning on --status-warning-weak,
 * radius 4, padding 2px 6px, no dot; its hint ("sample data") is the tooltip.
 */
export function DemoTag({ label, hint }: { label: string; hint?: string | null }) {
    return (
        <span
            data-testid="demo-marker"
            title={hint ?? undefined}
            className="shrink-0 rounded-[4px] bg-[var(--status-warning-weak)] px-[6px] py-[2px] text-[11px] leading-[14px] font-semibold tracking-[0.5px] text-[var(--text-warning)]"
        >
            {label}
        </span>
    )
}

export function TenantMark({
    logoUrl,
    name,
    logoHeight,
    demoLabel,
    demoHint,
}: {
    logoUrl?: string | null
    name: string
    logoHeight?: number | null
    demoLabel?: string | null
    demoHint?: string | null
}) {
    return (
        <span className="flex shrink-0 items-center gap-[12px]">
            {logoUrl ? (
                <img src={logoUrl} alt={name} style={{ height: `${logoHeight ?? 12}px` }} className="block w-auto" />
            ) : (
                <span className="text-[16px] leading-[24px] font-[550] text-[var(--text-default)]">{name}</span>
            )}
            {demoLabel && <DemoTag label={demoLabel} hint={demoHint} />}
        </span>
    )
}
